import {
  Dispatch,
  FormEventHandler,
  SetStateAction,
  SyntheticEvent,
  useState,
} from "react";
import { useI18n } from "i18n";
import { Button } from "@remo-co/ui-core/src/components/Button";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { FormTextInput } from "@remo-co/ui-core/src/components/FormTextInput";
import { ChevronLeft } from "@remo-co/ui-core/src/icons/ChevronLeft";
import useAuth from "modules/auth/hooks/useAuth";
import { useStyles } from "./styles";

interface Props {
  setShowUserNameForm: Dispatch<SetStateAction<boolean>>;
}

export const UserNameToRegister = ({
  setShowUserNameForm,
}: Props): JSX.Element => {
  const styles = useStyles();
  const { t } = useI18n(["common", "eventLanding", "auth"]);
  const [fullName, setFullName] = useState("");
  const [loading, setLoading] = useState(false);
  const { anonymousUserSignUp } = useAuth();

  const onBackClick = () => {
    setShowUserNameForm(false);
  };

  const handleFormSubmit: FormEventHandler<HTMLFormElement> = async (
    e: SyntheticEvent<HTMLFormElement>,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);

    await anonymousUserSignUp(fullName);
  };

  return (
    <div>
      <Button
        onClick={onBackClick}
        className={styles.backButton}
        data-testid="back-button"
        variant="ghost"
        color="dark"
        isIconButton
      >
        <ChevronLeft /> {t("button.back")}
      </Button>
      <form
        data-testid="enter-name-form"
        onSubmit={handleFormSubmit}
        className={styles.form}
      >
        <Typography className={styles.infoHeading} variant="h4">
          {t("enter.name")}
        </Typography>
        <Typography className={styles.infoText} variant="body1">
          {t("auth:anonymous.login.disclaimer")}
        </Typography>
        <FormTextInput
          id="name-input"
          placeholder={t("your.name")}
          label={t("your.name")}
          fullWidth
          InputLabelProps={{ shrink: true }}
          name="name"
          value={fullName}
          onChange={(event) => {
            setFullName(event.target.value);
          }}
          classes={{ root: styles.textField }}
        />
        <Button
          fullWidth
          disabled={!fullName.length}
          loading={loading}
          variant="secondary"
          color="blue"
          type="submit"
          data-testid="continue-button"
        >
          {t("continue")}
        </Button>
      </form>
    </div>
  );
};
